import CONFIG from "@rentiohq/shared/dist/config/app.config";
import api from "../../utils/api/api.utils";
export var getFlags = function () {
    return api.get("https://frontend-feature-flags.s3-eu-west-1.amazonaws.com/" + CONFIG.ENVIRONMENT.toLowerCase() + ".json", { isFullUrl: true, isRentioUrl: false });
};
